import React from 'react';

import { CONSULT_TABS } from 'features/consults/utils/constants';
import DemographicsHeader from 'features/consults/components/DemographicsHeader/DemographicsHeader';
import ROS from 'features/consults/shared/tabs/ROS';
import Exam from 'features/consults/shared/tabs/Exam';
import PMHFHSH from 'features/consults/shared/tabs/PMHFHSH';
import Assessment from 'features/consults/shared/tabs/Assessment';
import Summary from 'features/consults/shared/tabs/Summary';

import DemographicsNeuro from './DemographicsNeuro/DemographicsNeuro';
import HPINeuro from './HPINeuro/HPINeuro';
import ScoresNeuro from './ScoresNeuro/ScoresNeuro';

import DataNeuro from './DataNeuro/DataNeuro';

import SignatureNeuro from './SignatureNeuro/SignatureNeuro';
import Plan from './Plan';
import IVIA from './IVIA';

export default {
  demographics: {
    value: CONSULT_TABS.DEMOGRAPHICS,
    label: <DemographicsHeader />,
    component: DemographicsNeuro,
  },
  hpi: {
    value: CONSULT_TABS.HPI,
    label: 'HPI',
    component: HPINeuro,
  },
  scores: {
    value: CONSULT_TABS.SCORES,
    label: 'Scores',
    component: ScoresNeuro,
  },
  exam: {
    value: CONSULT_TABS.EXAM,
    label: 'Exam',
    component: Exam,
  },
  ros: {
    value: CONSULT_TABS.ROS,
    label: 'ROS',
    component: ROS,
  },
  pmh: {
    value: CONSULT_TABS.PMH,
    label: 'PMH-FH-SH',
    component: () => <PMHFHSH />,
  },
  data: {
    value: CONSULT_TABS.DATA,
    label: 'Data',
    component: DataNeuro,
  },
  assessment: {
    value: CONSULT_TABS.ASSESSMENT,
    label: 'Assessment',
    component: Assessment,
  },
  ivia: {
    value: CONSULT_TABS.IVIA,
    label: 'IV/IA',
    component: IVIA,
  },
  plan: {
    value: CONSULT_TABS.PLAN,
    label: 'Plan',
    component: Plan,
  },
  signature: {
    value: CONSULT_TABS.SIGNATURE,
    label: 'Signature/Billing',
    component: SignatureNeuro,
  },
  summary: {
    value: CONSULT_TABS.SUMMARY,
    label: 'Summary',
    component: Summary,
  },
};
